import moment from 'moment-jalaali';
import {useLocale} from "@redlink/assets/locale";

export const useDateFormat = () => {
    const {language} = useLocale();

    if (language === 'fa')
        moment.updateLocale('fa', {
            relativeTime: {
                future: 'در %s',
                past: '%s پیش',
                s: 'چند لحظه',
                ss: '%d ثانیه',
                m: '۱ دقیقه',
                mm: '%d دقیقه',
                h: '۱ ساعت',
                hh: '%d ساعت',
                d: '۱ روز',
                dd: '%d روز',
                w: '۱ هفته',
                ww: '%d هفته',
                M: '۱ ماه',
                MM: '%d ماه',
                y: '۱ سال',
                yy: '%d سال',
            },
        });

    return {
        getRelativeDateString: (time) => {
            return moment(new Date(time)).fromNow();
        },

        getDateString: (time) => {
            return moment(new Date(time)).format('jYY/jMM/jDD');
        },

        getTimeString: (time) => {
            return moment(new Date(time)).format('HH:mm');
        },
    };
};
